import React from 'react';
import PropTypes from 'prop-types';
import intelligentFormat from 'dibs-currency-helpers/intelligentFormat';
import { createFragmentContainer } from 'react-relay';

import pinterestUtils from '../../utils/social/pinterest';
import style from './ConnectAccountsModal-style.scss';

// Components
import ContextComponent from '../ContextComponent';
import LogoNoRegIcon from 'dibs-vg/dist/react/logo-no-reg';
import HeartFilledIcon from 'dibs-vg/dist/react/heart-filled';
import ArrowRightIcon from 'dibs-vg/dist/react/arrow-right';
import PinterestIcon from 'dibs-vg/dist/react/pinterest';

import PrimaryButton from 'dibs-elements/dist/Button/Primary';
import BarHeader from 'dibs-elements/dist/BarHeader';
import ModalBody from 'dibs-elements/dist/ModalBody';
import ModalCloseButton from 'dibs-elements/dist/ModalCloseButton';
import ModalContainer from 'dibs-elements/dist/ModalContainer';

import SanitizeHtml from '../SanitizeHtml';

const ALLOWED_TAGS = ['br', 'a', 'span'];
const ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title'],
    span: ['class'],
};

class ConnectAccountsModal extends ContextComponent {
    constructor(props) {
        super(props);
        this.openOath = this.openOath.bind(this);
    }

    openOath() {
        const { relay, clientId, userId, onSuccess, onClose } = this.props;
        const { tracking } = this.props;
        const pinterestWindow = pinterestUtils.openWindow();
        pinterestUtils.track(tracking.connectClicked);
        pinterestUtils.connectAccounts({
            relay,
            clientId,
            userId,
            pinterestWindow,
            onSuccess,
            tracking: tracking.connectSuccessful,
        });

        onClose();
    }

    _getContent() {
        const { item } = this.props;
        const { title, image, seller } = item || {};

        if (!item) {
            return null;
        }

        return (
            <div className={style.contentHolder}>
                <div className={style.dibs}>
                    <LogoNoRegIcon className={style.dibsIcon} />
                    <img className={style.dibsImage} src={image.src} />
                    <div className={style.title}>{title}</div>
                    {this._getPrice()}
                    <div className={style.seller}>{seller}</div>
                    <HeartFilledIcon className={style.star} />
                    <ArrowRightIcon className={style.arrow} />
                </div>

                <div className={style.pinterest}>
                    <PinterestIcon className={style.pinterestIcon} />
                    <img className={style.pinterestImage} src={image.src} />
                    <div className={style.pinterestFooter}>from 1stdibs.com</div>
                </div>
            </div>
        );
    }

    _getPrice() {
        const { currency, item: { price } } = this.props;

        if (!price) {
            return null;
        }
        return <div className={style.price}>{intelligentFormat(price, currency)}</div>;
    }

    render() {
        const { copy, isOpen, onClose } = this.props;

        return (
            <ModalContainer isOpen={isOpen} onClose={onClose} closeOnEsc modalPosition="center">
                <BarHeader title={copy.header} />
                <ModalCloseButton onClick={onClose} />
                <ModalBody className={style.content}>
                    <p className={style.description}>
                        <SanitizeHtml
                            allowedTags={ALLOWED_TAGS}
                            allowedAttributes={ALLOWED_ATTRIBUTES}
                            content={copy.description}
                        />
                    </p>

                    {this._getContent()}

                    <PrimaryButton onClick={this.openOath} className={style.button}>
                        {copy.cta}
                    </PrimaryButton>
                    <div>
                        <a onClick={onClose} className={style.footerLink} href="#0">
                            {copy.cancel}
                        </a>
                    </div>
                </ModalBody>
            </ModalContainer>
        );
    }
}

ConnectAccountsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    item: PropTypes.object,
    currency: PropTypes.string,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object,
    }),
};

export default createFragmentContainer(ConnectAccountsModal, {});



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/ConnectAccountsModal.jsx